import { cn, Typography } from '@execonline-inc/execonline-ui';
import { TranslationsContext } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { T, translation } from '../../../../../../Translations';
import { Message } from '../../../../ChatStores/ChatStore/Types';
import { colorForRole } from '../../../../Types';
import ChatMessageBody from './ChatMessageBody';

interface Props {
  message: Message;
}

function ChatDisplayHistory({ message }: Props) {
  switch (message.role) {
    case 'assistant':
      return (
        <div
          className={cn(
            'flex flex-col py-6 px-4 whitespace-pre-wrap gap-y-2',
            colorForRole(message.role),
          )}
        >
          <div className="flex items-center justify-start gap-x-2">
            <TranslationsContext.Consumer>
              {(ts) => (
                <img
                  src="/exo-logo.png"
                  className="size-6"
                  alt={translation('EXO AI Assistant Logo')(ts)}
                />
              )}
            </TranslationsContext.Consumer>
            <Typography variant="bodyMedium" fontWeight="semibold">
              <T kind="EXO, AI Advisor" />
            </Typography>
          </div>
          <ChatMessageBody content={message.content} className="text-sm font-normal break-words" />
        </div>
      );
    case 'user':
      return (
        <div className="grid justify-end px-5">
          <Typography
            className={cn(
              'px-3 py-2 break-words whitespace-pre-wrap min-w-0',
              colorForRole(message.role),
            )}
            variant="bodyMedium"
            as="div"
          >
            {message.content}
          </Typography>
        </div>
      );
  }
}
export default observer(ChatDisplayHistory);
